import common from './common';

const toolService = {
  ...common('tools')
};
export { toolService };
